import Vue from 'vue';
import VueResource from 'vue-resource';
import converterObjetoFormData from '~js/converter-objeto-formdata';
import salvarArquivo from '~js/salvar-arquivo';
import formatarData from '~js/formatar-data';

Vue.use(VueResource);

function prepararParaSalvarFornecedor(fornecedor) {
  if (!fornecedor.complemento) {
    fornecedor.complemento = '';
  }
  return fornecedor;
}

function prepararParaExibirFornecedor(fornecedor) {
  // Caso em que NAO existem respostas
  if (fornecedor.formRespostasFornecedor.length === 0) {
    for (let i = 1; i <= 9; i = i + 1) {
      fornecedor.formRespostasFornecedor.push({
        idFormPergunta: i,
        idFornecedor: '',
        resposta: null,
        dataCriacao: null,
      });
    }
  } else { // Caso em que existem respostas
    for (let formResposta of fornecedor.formRespostasFornecedor) {
      switch (formResposta.resposta) {
        case 0: formResposta.resposta = '0'; break;
        case 1: formResposta.resposta = '1'; break;
        case 2: formResposta.resposta = '2'; break;
        default: formResposta.resposta = null;
      }
    }
  }

  if (fornecedor.certidoes.length > 0) {
    for (let certidao of fornecedor.certidoes) {
      if (!certidao.nomeArquivo || certidao.nomeArquivo === "undefined") {
        certidao.nomeArquivo = "Sem arquivo";
      }
    }
  }

  return fornecedor;
}

async function prepararParaSalvar(pessoa) {

  if (pessoa.dataNascimento) {
    pessoa.dataNascimento = await formatarData.paraNumero(pessoa.dataNascimento);
  }

  return pessoa;
}

export default {
  alunos: () => {
    return Vue.http.get('/api/pessoas/alunos')
      .then(resposta => resposta.body);
  },
  busca: documento => {
    return Vue.http.get('/api/pessoas/busca', {
      params: {
        documento
      }
    })
    .then(resposta => resposta.body);
  },
  buscaestrangeiro: email => {
    return Vue.http.get('/api/pessoas/buscaestrangeiro', {
      params: {
        email
      }
    })
      .then(resposta => resposta.body);
  },
  fornecedor: () => {
    return Vue.http.get('/api/pessoas/fornecedor')
      .then(resposta => prepararParaExibirFornecedor(resposta.body));
  },
  alterarFornecedor: (fornecedor, arquivos, arquivosCertidao) => {
    fornecedor = prepararParaSalvarFornecedor(fornecedor);

    fornecedor.arquivos = arquivos;
    fornecedor.arquivosCertidao = arquivosCertidao;

    fornecedor = converterObjetoFormData(fornecedor);

    return Vue.http.put('/api/pessoas/fornecedor', fornecedor)
      .then(resposta => resposta.body);
  },
  dadosBancarios: documento => {
    return Vue.http.get('/api/pessoas/DadosBancarios', {
      params: {
        documento
      }
    })
    .then(resposta => resposta.body);
  },
  dadosBancariosPIX: documento => {
    return Vue.http.get('/api/pessoas/DadosBancariosPIX', {
      params: {
        documento
      }
    })
      .then(resposta => resposta.body);
  },
  arquivos: id => {
      return Vue.http.get(`/api/pessoas/${id}/arquivos`)
          .then(response => response.data);
  },

  arquivosCertidao: (idCertidao) => {
    return Vue.http.get(`/api/pessoas/${idCertidao}/arquivoCertidao`)
      .then(response => response.data);
  },

  download: (id, arquivo) => {
      return Vue.http.get(`/api/pessoas/${id}/downloadarquivo/${arquivo}`, {
          responseType: 'blob'
      })
          .then(response => {
              return salvarArquivo(response, arquivo);
          });
  },

  downloadCertidao: (idCertidaoPessoa, arquivoCertidao) => {
    return Vue.http.get(`/api/pessoas/${idCertidaoPessoa}/downloadarquivocertidao/${arquivoCertidao}`, {
      responseType: 'blob'
    })
      .then(response => {
        return salvarArquivo(response, arquivoCertidao);
      });
  },

  pessoa: () => {
    return Vue.http.get('/api/pessoas/pessoafisica')
      .then(resposta => resposta.body);
  },
  alterarPessoa: async (pessoa, arquivos) => {
    pessoa = await prepararParaSalvar(pessoa);
    pessoa.arquivos = arquivos;

    pessoa = converterObjetoFormData(pessoa);

    return Vue.http.put('/api/pessoas/pessoafisica', pessoa)
      .then(resposta => resposta.body);
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/pessoa/servico.js